import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IReturnChangesWidgetEditForm, alignmentTypes, checkIfFieldDisabled, defaultColors, isDateTimeGetTimeSeconds, widgetEditMode } from 'na-lib';
import { validColorValidator } from 'src/app/validators/color.validator';
import { SettingsService } from 'src/app/service/settings.service';

@Component({
    selector: 'app-countdown-edit-form',
    templateUrl: './countdown-edit-form.component.html',
    styleUrl: './countdown-edit-form.component.css',
    standalone: false
})

export class CountdownEditFormComponent {
  @Input() data:widgetEditMode;
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>();

  defaultLanguage:string
  widgetNumber:any
  passId:any
  countdownData:any
  oldData:any
  translationModeOriginal = false
  countdownEditForm!:FormGroup
  invalid_background = false
  invalid_textColor = false
  colorPalette:any=[]
  lessMinDate = false
  userHasBetaWidgetRole = false
  alignmentTypes = alignmentTypes
  defaultColors = defaultColors
  
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private settingsService: SettingsService
  ){}

  ngOnInit():void{
    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true
    
    this.defaultLanguage = this.data.defaultLanguage
    this.countdownData=this.data.values
    this.oldData=this.countdownData
    this.passId = this.data.passId
    this.widgetNumber= this.data.widget

    if(this.data.translateMode){
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()

    this.initializePaletteColors()
  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){
    let { type, id, name, targetDate, targetDateKey, expiredMessage,filter, alignment, textColor, backgroundColor, widgetStyle} = data
    let date, valuerange1
   
    if(targetDate){
      date = isDateTimeGetTimeSeconds(targetDate)
      let dateEx = new Date(date).toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'}).split('.')
      const year = String(dateEx[2]).padStart(4,'0')
      valuerange1 = year +'-'+ dateEx[1] +'-' + dateEx[0] + 'T' + new Date(date).toLocaleTimeString('de-DE',{ hour: "2-digit", minute: "2-digit" })
    }

    if(!originalLanguageData)
      expiredMessage = valuesTranslated[selectedLanguage +'.'+id+'.expiredMessage']

    this.countdownEditForm =  this.fb.group({
      type: [{value:type ? type: undefined,disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      id:[{value: id? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      
      name: [{value:name ? name : undefined , disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      targetDate: [{value:valuerange1 ? valuerange1 : undefined , disabled: checkIfFieldDisabled('targetDate', fields, originalLanguageData)}],
      targetDateKey: [{value:targetDateKey ? targetDateKey : undefined , disabled: checkIfFieldDisabled('targetDateKey', fields, originalLanguageData)}],
      expiredMessage: [{value:expiredMessage ? expiredMessage : undefined , disabled: checkIfFieldDisabled('expiredMessage', fields, originalLanguageData)}],
      filter: [{value:filter ? filter : undefined , disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      
      alignment: [{value:alignment ? alignment : undefined , disabled: checkIfFieldDisabled('alignment', fields, originalLanguageData)}],
      backgroundColor: [{value:backgroundColor ? backgroundColor : undefined , disabled: checkIfFieldDisabled('backgroundColor', fields, originalLanguageData)}],
      textColor: [{value:textColor ? textColor : undefined , disabled: checkIfFieldDisabled('textColor', fields, originalLanguageData)}],
      widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:checkIfFieldDisabled('widgetStyle', fields, originalLanguageData)}]
    })

    this.countdownEditForm.valueChanges.subscribe( value => {
      this.returnChanges.emit({
        type:"countdown",
        form: this.countdownEditForm,
        validForm: this.countdownEditForm.valid,
        translations:{expiredMessage: value.expiredMessage},
        saveDisabled: false
      })
    })

  }

  initWidgetEdit(){
    const { type, id, name, targetDate, targetDateKey, expiredMessage,filter, alignment, textColor, backgroundColor, widgetStyle} = this.countdownData
    let date, valuerange1
    if(targetDate){
       date = isDateTimeGetTimeSeconds(targetDate)
      let dateEx = new Date(date).toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'}).split('.')
      const year = String(dateEx[2]).padStart(4,'0')
      valuerange1 = year +'-'+ dateEx[1] +'-' + dateEx[0] + 'T' + new Date(date).toLocaleTimeString('de-DE',{ hour: "2-digit", minute: "2-digit" })
    }
    
    this.countdownEditForm = this.fb.group({
      type:[{value: type ? type : undefined, disabled:false}],
      id:[{value: id ? id : undefined, disabled:false}],
      name:[{value: name ? name : undefined, disabled:false}],
      targetDate:[{value: valuerange1 ? valuerange1 : undefined, disabled:false}, [Validators.required]],
      targetDateKey:[{value: targetDateKey ? targetDateKey : undefined, disabled:false}],
      expiredMessage:[{value: expiredMessage ? expiredMessage : undefined, disabled:false}, [Validators.required]],
      filter:[{value: filter ? filter : undefined, disabled:false}],
      alignment:[{value: alignment ? alignment : undefined, disabled:false}],
      backgroundColor:[{value: backgroundColor ? backgroundColor : this.defaultColors.backgroundColor, disabled:false}, [validColorValidator()]],
      textColor:[{value: textColor ? textColor : this.defaultColors.textColor, disabled:false}, [validColorValidator()]],
      widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}]
    })

    this.countdownEditForm.get("targetDate").valueChanges.subscribe( value => {
      this.checkMinimumDate(value)
    })

    this.countdownEditForm.valueChanges.subscribe( value => {
      this.returnChanges.emit({
        type:"countdown",
        form: this.countdownEditForm,
        validForm: this.countdownEditForm.valid,
        data:value,
        saveDisabled: this.invalid_background || this.invalid_textColor || !this.countdownEditForm.valid
      })
      this.checkInvalidColors()
    })

    this.checkInvalidColors()
  }


  initializePaletteColors(){
    let accent  = document.documentElement.style.getPropertyValue('accent')
    let background = document.documentElement.style.getPropertyValue('background')

    var colors=[]
    const warmOrange= getComputedStyle(document.documentElement).getPropertyValue('--warmOrange')
    const darkblue= getComputedStyle(document.documentElement).getPropertyValue('--darkBlue')
    const pureWhite= getComputedStyle(document.documentElement).getPropertyValue('--pureWhite')
    const neutral= getComputedStyle(document.documentElement).getPropertyValue('--neutral')
    colors.push(warmOrange)
    colors.push(darkblue)
    colors.push(pureWhite)
    colors.push(neutral)
    this.colorPalette=colors
  }

  checkInvalidColors(){
    if(this.countdownEditForm.controls['backgroundColor'].hasError('invalidColor'))
      this.invalid_background=true
    else
      this.invalid_background=false
    

    if(this.countdownEditForm.controls['textColor'].hasError('invalidColor'))
      this.invalid_textColor=true
    else
      this.invalid_textColor=false
  }

  checkMinimumDate(value){
    const minDate = new Date('1970-01-01T00:00').getFullYear()
    const date = new Date(value).getFullYear()

    if(date){
      if (minDate > date)
        this.lessMinDate = true
      else
        this.lessMinDate = false
    }
  }

  returnChangesFilters($event){
    this.countdownEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.countdownEditForm.patchValue({widgetStyle: $event.newStyle})
  }

}
